import e from "./Typography.module.js";
import t from "classnames";
import { createElement as n, forwardRef as r } from "react";
//#region src/components/Typography/Typography.tsx
function i(e, i) {
	return r(({ className: r, ...a }, o) => n(e, {
		ref: o,
		className: t(i(a), r),
		...a
	}));
}
var a = i("span", () => e.accentText), o = i("span", ({ semibold: n, upper: r }) => t(e.smallText, {
	[e.smallText_semibold]: n,
	[e.smallText_upper]: r
})), s = i("span", () => e.subtitle), c = i("span", ({ italic: n }) => t(e.text, { [e.text_italic]: n })), l = i("span", () => t(e.text, e.secondaryText)), u = i("span", ({ bold: n }) => t(e.monoText, { [e.monoText_bold]: n }));
//#endregion
export { a as AccentText, u as MonoText, l as SecondaryText, o as SmallText, s as Subtitle, c as Text, i as createTypographyComponent, e as typographyStyles };
